import React from 'react';
import AbstractLayout from '../AbstractLayout';

export default class EmptyLayout extends AbstractLayout {
    protected supportsBreadcrumbs = false;

    render() {
        return <div className="empty-layout">{this.props.children}</div>;
    }
}
